import { render } from "./MainappWelcome.vue?vue&type=template&id=7cc297e6"
import script from "./MainappWelcome.vue?vue&type=script&lang=js"
export * from "./MainappWelcome.vue?vue&type=script&lang=js"
script.render = render

export default script